export class VirtualRepeaterHeadingComponent implements angular.IComponentOptions {
    public static $name: string = 'virtualRepeaterHeading';

    public bindings: any = {
        text: '@',
        width: '<'
    };

    public controller = VirtualRepeaterHeadingController;

    public template: string = `
        <div>
            <span>
                {{ $ctrl.text }}
                <md-tooltip ng-if="$ctrl.text">{{ $ctrl.text }}</md-tooltip>
            </span>
        </div>
    `;
}

// tslint:disable-next-line: max-classes-per-file
export class VirtualRepeaterHeadingController implements angular.IComponentController {
    private static $inject: string[] = [
        '$element'
    ];

    /* A percentage value to use for flex */
    private width: number;

    /* The display value */
    private text: string;

    constructor(
        private $element: angular.IAugmentedJQuery
    ) {
    }

    public $onInit() {
        // We want attributes to be applied to the original (outer) element, best place to do that is here
        this.$element.addClass('hide show-gt-sm layout-column');
        this.$element.addClass('flex-' + this.width);
    }
}
